<template>
  <modal @close="$emit('close')" :maxWidth="700">
    <div class="card text-left" style="width: 100%">
      <div class="card-header d-flex justify-content-between bg-transparent">
        <div v-if="editFeature">Edit Feature</div>
        <div v-else>Add New Feature</div>
        <div>
          <span style="cursor: pointer" @click="$emit('close')"
            ><i class="fa fa-times"></i
          ></span>
        </div>
      </div>
      <div class="card-body">
        <div class="mb-2">
          <label for="recipient-name" class="col-form-label"
            >Type: {{ type == "location" ? "Location" : "Company" }}</label
          >
        </div>
        <div class="mb-2">
          <label for="recipient-name" class="col-form-label">Key:</label>
          <input
            type="text"
            class="form-control"
            name="key"
            v-validate="'required|regex:^[a-zA-Z0-9.-]+$'"
            v-model="feature.key"
          />
          <span class="error text-danger small" v-if="errors.has('key')">
            {{ errors.first("key") }}
          </span>
        </div>
        <div class="mb-2">
          <label for="recipient-name" class="col-form-label">Name:</label>
          <input
            type="text"
            class="form-control"
            name="name"
            v-validate="'required'"
            v-model="feature.name"
          />
          <span class="error text-danger small" v-if="errors.has('name')">
            {{ errors.first("name") }}
          </span>
        </div>
        <div class="mb-2">
          <label for="recipient-name" class="col-form-label">Heading:</label>
          <input
            type="text"
            class="form-control"
            name="heading"
            v-validate="'required'"
            v-model="feature.details.heading"
          />
          <span class="error text-danger small" v-if="errors.has('heading')">
            {{ errors.first("heading") }}
          </span>
        </div>
        <div class="mb-2">
          <label for="recipient-name" class="col-form-label">Details</label>
          <Editor v-model="feature.details.body" />
          <input
            v-show="false"
            type="text"
            name="body"
            v-validate="'required'"
            v-model="feature.details.body"
            tabindex="-1"
            aria-hidden="true"
          />
          <span class="error text-danger small" v-if="errors.has('body')">
            {{ errors.first("body") }}
          </span>
        </div>
        <div class="mb-2">
          <label for="recipient-name" class="col-form-label"
            >Changelog URL:</label
          >
          <input
            type="text"
            class="form-control"
            name="changelog"
            v-validate="'url'"
            v-model.trim="feature.changelog"
          />
          <span class="error text-danger small" v-if="errors.has('changelog')">
            {{ errors.first("changelog") }}
          </span>
        </div>
        <div class="mb-2">
          <label for="recipient-name" class="col-form-label"
            >Support Doc URL:</label
          >
          <input
            type="text"
            class="form-control"
            name="support_doc"
            v-validate="'url'"
            v-model.trim="feature.supportDoc"
          />
          <span
            class="error text-danger small"
            v-if="errors.has('support_doc')"
          >
            {{ errors.first("support_doc") }}
          </span>
        </div>
        <div class="mb-2">
          <label for="recipient-name" class="col-form-label">Media URLs:</label>
          <div
            class="d-flex align-items-start mb-2"
            v-for="(_, index) in feature.media"
            :key="index"
          >
            <div class="w-100">
              <input
                type="text"
                class="form-control"
                :name="`media_${index}`"
                v-validate="'url'"
                v-model.trim="feature.media[index]"
              />
              <span
                class="error text-danger small"
                v-if="errors.has(`media_${index}`)"
              >
                {{ errors.first(`media_${index}`) }}
              </span>
            </div>
            <button
              type="button"
              class="btn btn-outline-danger ml-2"
              @click="removeMediaUrl(index)"
            >
              Remove
            </button>
          </div>
          <button
            type="button"
            class="btn btn-outline-primary btn-sm"
            @click="addMediaUrl"
          >
            Add Media URL
          </button>
        </div>
        <label class="col-form-label">Schedule:</label>
        <div class="d-flex justify-content-between align-items-center mb-2">
          <div class="px-1" style="width: 30%">
            <vue-ctk-date-time-picker
              label="Visible At"
              v-model="feature.visibleAt"
              v-validate="'required'"
              :range="false"
              color="#188bf6"
              :only-date="true"
              :noClearButton="false"
              auto-close
              output-format="YYYY-MM-DD"
              name="visible_at"
            />
            <span
              class="error text-danger small"
              v-if="errors.has('visible_at')"
            >
              {{ errors.first("visible_at") }}
            </span>
          </div>
          <div class="px-1" style="width: 30%">
            <vue-ctk-date-time-picker
              label="Enabled At"
              v-model="feature.enabledAt"
              :range="false"
              color="#188bf6"
              :only-date="true"
              :noClearButton="false"
              :disabled="type === 'location'"
              auto-close
              output-format="YYYY-MM-DD"
              name="enabled_at"
            />
          </div>
          <div class="px-1" style="width: 30%">
            <vue-ctk-date-time-picker
              label="Live At"
              v-model="feature.liveAt"
              v-validate="'required'"
              :range="false"
              color="#188bf6"
              :only-date="true"
              :noClearButton="false"
              auto-close
              output-format="YYYY-MM-DD"
              name="live_at"
            />
            <span class="error text-danger small" v-if="errors.has('live_at')">
              {{ errors.first("live_at") }}
            </span>
          </div>
        </div>
        <div class="d-flex justify-content-between align-items-center mb-2">
          <div class="px-1" style="width: 50%">
            <label for="inputState" class="col-form-label">Toggle Hidden</label>
            <select
              id="inputState"
              class="form-control"
              v-model="feature.toggleHidden"
            >
              <option :value="false" selected>No</option>
              <option :value="true">Yes</option>
            </select>
          </div>
          <div class="px-1" style="width: 50%">
            <label for="inputState" class="col-form-label">Default Value</label>
            <select
              id="inputState"
              class="form-control"
              :disabled="type === 'location'"
              v-model="feature.default"
            >
              <option :value="false" selected>False</option>
              <option :value="true">True</option>
            </select>
          </div>
        </div>
        <div class="d-flex justify-content-between align-items-center mb-2">
          <div class="px-1" style="width: 50%">
            <label for="inputState" class="col-form-label">
              Is Irreversible Feature</label
            >
            <select
              id="inputState"
              class="form-control"
              v-model="feature.isIrreversibleFeature"
            >
              <option :value="false" selected>False</option>
              <option :value="true">True</option>
            </select>
          </div>
          <div class="px-1" style="width: 50%">
            <label for="inputState" class="col-form-label"> Hide from UI</label>
            <select
              id="inputState"
              class="form-control"
              v-model="feature.isHiddenFromUi"
            >
              <option :value="false" selected>False</option>
              <option :value="true">True</option>
            </select>
          </div>
        </div>
      </div>
      <div class="card-footer d-flex justify-content-between bg-transparent">
        <div></div>
        <div class="">
          <button
            class="btn btn-success"
            @click="save()"
            :disabled="saving || errors.any()"
          >
            <moon-loader
              v-if="saving"
              :loading="true"
              color="white"
              size="15px"
            />
            <span v-else>Save</span>
          </button>
        </div>
      </div>
    </div>
  </modal>
</template>
<style scoped>
.card-body {
  max-height: 80vh;
  overflow-y: scroll;
}
</style>
<script>
import modal from "@/components/common/Modal.vue";
import Editor from "./editor.vue";
import LabsService from "../../services/LabsService";
import { emitter, NotificationType } from "@/composables/emitter";

export default {
  components: { modal, Editor },
  props: {
    editFeature: { type: Object, default: null },
    type: { type: String, default: "location" },
  },
  data() {
    const feature = this.editFeature || {};

    return {
      feature: {
        type: feature.type || this.type,
        key: feature.key || "",
        name: feature.name || "",
        details: {
          heading: feature.details?.heading || "",
          body: feature.details?.body || "",
        },
        liveAt: feature.liveAt || null,
        enabledAt: feature.enabledAt || null,
        visibleAt: feature.visibleAt || null,
        toggleHidden: Boolean(feature.toggleHidden),
        default: Boolean(feature.default),
        isIrreversibleFeature: Boolean(feature.isIrreversibleFeature),
        isHiddenFromUi: Boolean(feature.isHiddenFromUi),
        changelog: feature.changelog || "",
        supportDoc: feature.supportDoc || "",
        media: Array.isArray(feature.media) ? [...feature.media] : [],
      },
      saving: false,
    };
  },
  methods: {
    async save() {
      try {
        await this.$validator.validateAll();
        const errors = this.errors.any();
        if (errors) return;
        this.saving = true;
        const payload = {
          ...this.feature,
          media: (this.feature.media || []).filter((mediaUrl) => mediaUrl),
        };
        if (this.editFeature?._id) {
          const { data: updatedFeature } = await LabsService.updateLabsFeature(
            this.editFeature._id,
            payload
          );
          this.$emit("updated", updatedFeature);
        } else {
          const { data: feature } = await LabsService.createLabsFeature(
            payload
          );
          this.$emit("created", feature);
        }
        this.$emit("close");
      } catch (error) {
        emitter.$emit("notification", {
          title: `Failed to ${
            this.editFeature?._id ? "update" : "create"
          } feature`,
          message: error?.response?.data?.message || error.message,
          type: NotificationType.ERROR,
        });
      } finally {
        this.saving = false;
      }
    },
    addMediaUrl() {
      if (!Array.isArray(this.feature.media)) {
        this.$set(this.feature, "media", []);
      }
      this.feature.media.push("");
    },
    removeMediaUrl(index) {
      const fieldName = `media_${index}`;
      this.errors.remove(fieldName);
      this.$validator.detach(fieldName);
      this.feature.media.splice(index, 1);
    },
  },
};
</script>
